import { combineReducers } from "@reduxjs/toolkit";
import scenarioReducer from "./slices/scenarioSlice";
import gameReducer from "./slices/gameSlice";
import dashboardReducer from "./slices/dashboardSlice";
import usersReducer from "./slices/usersSlice";
import settingsReducer from "./slices/settingsSlice";
import characterReducer from "./slices/characterSlice";
import sidekickuserReducer from "./slices/sidekickuserSlice";
import sidekickstatReducer from "./slices/sidekickStatSlice";
import sidekickproductReducer from "./slices/sidekickProductsSlice";
import previewBooksReducer from "./slices/previewBooksSlice";
import creators from "./slices/creatorSlice";
import storeLocationReducer from "./slices/storeLocationSlice";
import upcomingFeatureReducer from "./slices/upcomingFeatureSlice";
import manualPayouts from "./slices/manualPayoutsSlice";

export default combineReducers({
  scenarioReducer,
  gameReducer,
  dashboardReducer,
  usersReducer,
  settingsReducer,
  characterReducer,
  sidekickuserReducer,
  sidekickstatReducer,
  sidekickproductReducer,
  previewBooksReducer,
  creators,
  storeLocationReducer,
  upcomingFeatureReducer,
  manualPayouts,
});
